"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetProducts = void 0;
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _productBox = require("@ori/product-box");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
/* istanbul ignore file */ const useGetProducts = (param)=>{
    let { productCodes, skip } = param;
    var _data_data;
    const { tenant } = (0, _environment.useEnvironment)();
    const { language } = (0, _i18n.useTranslationsWithNamespaces)();
    const { data, isValidating } = (0, _staticApiClientReact.useGetTenantApplicationsProductBox)(tenant, {
        lang: language,
        productCodes: productCodes !== null && productCodes !== void 0 ? productCodes : []
    }, {
        swr: {
            enabled: !skip,
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false
        }
    });
    return (0, _react.useMemo)(()=>{
        var _data_data;
        return {
            data: (data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.products) ? (0, _productBox.mapProductBoxesFromStaticApi)({
                data: data.data.products
            }) : null,
            loading: isValidating
        };
    }, [
        data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.products,
        isValidating
    ]);
};
exports.useGetProducts = useGetProducts;
